/** 
 * Override the following data to set the state you want to push when a modal activates
 *   modalStateKeys
 *
 * Override the following methods in this mixin for custom control
 *   save() - called when the modal is saved
 *   revertState() - called when the modal is canceled. Use this to revert state back
 *   pushState() - called when the modal opens. Use this to save your state in case of cancel
 *
 * Exposes methods
 *   activate() - opens the modal
 *   onCancel() - click handler
 *   onOkay() - click handler
 */

import BodyClasses from '@/include/bodyClasses';

export default {
  data() {
    return {
      modalActive: false,
      modalStateKeys: [],
      _modalState: null
    }
  },

  methods: {
    escapeKeyListener(evt) {
      if (evt.keyCode === 27 && this.modalActive) {
        this.onCancel();
      }
    },

    activate() {
      this.modalActive = true;
      this.pushState();
    },

    getValue() {
      let v = {}
      this.modalStateKeys.forEach(key => {
        if (this[key]) {
          v[key] = this[key];
        }
      });
      return v;
    },

    onCreate() {
      if (this.value) {
        this.modalStateKeys.forEach(key => {
          if (this.value[key]) {
            this[key] = this.value[key];
          }
        });
      }
    },

    onCancel() {
      this.modalActive = false;
      this.revertState();
    },

    onOkay() {
      this.modalActive = false;
      this.save();      
    },

    // ********** overridable ***********

    pushState() {
      this._modalState = this.modalStateKeys.map(key => {
        return { key: key, value: this[key] }
      });
    },

    revertState() {
      this._modalState.forEach(item => {
        this[item.key] = item.value;
      });
    },

    save() {
      // nothing to do
    }
  },

  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },

  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },

  watch: {
    modalActive(val) {
      if (!this.allowScrolling){
        BodyClasses.setClass('modal-active', val);
      } else {
        BodyClasses.setClass('modal-active', false);
      }
    }
  }

}